var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3651",
    "data-name": "Group 3651",
    transform: "translate(-721 -3614)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(721 3614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-protection-symbol-with-a-shield-svgrepo-com",
    transform: "translate(724.811 3625.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10708",
    "data-name": "Path 10708",
    d: "M18.613,12.229A6.114,6.114,0,1,0,12.5,6.114,6.114,6.114,0,0,0,18.613,12.229Zm2.858-3.683a2.909,2.909,0,0,1-2.9,1.611,2.909,2.909,0,0,1-2.9-1.611ZM33.55,18.09c-.131,3.622-1.6,6.735-5.044,7.881-3.439-1.146-4.912-4.259-5.044-7.881a.483.483,0,0,1,.505-.5,6.051,6.051,0,0,0,4.238-1.465.472.472,0,0,1,.6,0,6.051,6.051,0,0,0,4.238,1.465A.483.483,0,0,1,33.55,18.09Zm-11.14.038a12.021,12.021,0,0,0,.929,4.4,42.234,42.234,0,0,1-4.726.243c-5.9,0-8.781-.963-9.838-1.434a.913.913,0,0,1-.493-.767V18.554a5.921,5.921,0,0,1,5.234-5.862.489.489,0,0,1,.294.081,8.158,8.158,0,0,0,9.607,0,.489.489,0,0,1,.294-.081,5.918,5.918,0,0,1,4.123,2.434,1.5,1.5,0,0,0-.3.187,4.994,4.994,0,0,1-3.285,1.229c-.078,0-.157,0-.237-.005h-.065a1.537,1.537,0,0,0-1.538,1.592Z",
    fill: "#4cb48b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.19d2983047e2091df332b98a469eee98.svg";
export { ForwardRef as ReactComponent };